import React, { useState } from 'react'
import { useLeadTimesSourceSummary } from '../../hooks/queries/sourceSummary'
import SourceAccordians from './components/SourceAccordian/SourceAccordians'
import { useAllLeadTimes } from '../../hooks/queries/allLeadTimes'
import LeadTimesSourceData from './sections/LeadTimesSourceData'
import AllLeadTimesTable from '../sourceData/components/AllLeadTimesTable'
import { useQueryClient } from 'react-query'
import Loading from '../../components/Loading'
import { useAuth0 } from '@auth0/auth0-react'

export default function LeadTimesPage() {
  const [sheetData, setSheetData] = useState({})
  const [expanded, setExpanded] = useState(false)

  const sourceSummaryType = 'leadTimesSummary'
  const sourceSummaryQueryKey = 'leadTimesSourceSummary'
  const dataSummaryQueryKey = 'leadTimesTable'
  const pageDataType = 'leadTimes'

  const { user } = useAuth0()

  const { isFetching: iFSourceData } = useLeadTimesSourceSummary(sourceSummaryQueryKey, sourceSummaryType, {
    setSheetData,
  })

  const {
    isLoading: iLTableData,
    isErroxr: iETableData,
    isFetching: iFTableData,
    data: leadTimeTableData,
  } = useAllLeadTimes(dataSummaryQueryKey, 1000, 0, user?.email)

  const queryClient = useQueryClient()
  const refetchData = () => {
    queryClient.refetchQueries([sourceSummaryQueryKey])
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const refreshTableData = () => {
    queryClient.refetchQueries([dataSummaryQueryKey])
  }

  const setExpand = (val) => {
    setExpanded(val)
  }

  const sourceDataSources = iFSourceData
    ? []
    : [<LeadTimesSourceData refetchData={refetchData} uploadSummary={sheetData} key={0} setExpand={setExpand} />]

  const clearSheetData = () => {
    setSheetData({})
  }

  const tableData = iLTableData || iETableData || iFTableData ? [] : leadTimeTableData

  return (
    <>
      {iFSourceData ? (
        <Loading />
      ) : (
        <SourceAccordians
          label={'Lead Times'}
          sources={sourceDataSources}
          refetchData={refetchData}
          clearSheetData={clearSheetData}
          displayComp={<AllLeadTimesTable data={tableData} refreshTableData={refreshTableData} />}
          sourceSummaryQueryKey={sourceSummaryQueryKey}
          dataSummaryQueryKey={dataSummaryQueryKey}
          pageDataType={pageDataType}
          toExpand={expanded}
        />
      )}
    </>
  )
}
